export enum PrefixEnum {
    M = 'M',
    MR = 'MR',
    MISS = 'MISS',
    MLLE = 'MLLE',
    MRS = 'MRS',
    MS = 'MS',
    MME = 'MME',
    MANDMME = 'MANDMME',
    MRANDMRS = 'MRANDMRS',
    MRSANDMR = 'MRSANDMR',
    MM = 'MM',
    DR = 'DR',
    DRDOT = 'DRDOT',
    MAITRE = 'MAITRE',
    ME = 'ME',
    MX = 'MX',
    AUCUN = 'AUCUN',
    NONE = 'NONE'
}
